import { SET_HELP_LEAD_BUCKET } from '../actionTypes/index';
import { LEAD_BUCKETS } from '../../config/constants';

const initialState = {
	getHelpLeadBucket: LEAD_BUCKETS.general,
};

const getHelpReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_HELP_LEAD_BUCKET:
			if (action.payload) {
				return {
					...state,
					getHelpLeadBucket: action.payload
				}
			} else {
				return state;
			}
		default:
			return state;
	}
};
export default getHelpReducer;
